import { useEffect, useState } from 'react';
import { BrowserBaseClient } from './api-browser-base-client';
import { APIResponseModel, AuthenticationRequestResponse, RequestOtpInputModel, VerifyOtpInputModel } from '@models/api';

export class BrowserIdentityClient extends BrowserBaseClient {
  private readonly service: string = 'identity';
  private readonly serviceUrl: string = `${this.apiBaseUrl}/${this.service}`;

  constructor() {
    super(window.__ENV__.API_URL);
  }

  public async Logout(): Promise<APIResponseModel<void>> {
    const url = `${this.serviceUrl}/user/logout`;
    return await this.get<void>(url);
  }

  public async ResendLoginOtp(req: AuthenticationRequestResponse): Promise<APIResponseModel<AuthenticationRequestResponse>> {
    const url = `${this.serviceUrl}/auth/respond-to-auth`;
    delete req.data["otp"];
    return this.publicPost<AuthenticationRequestResponse, AuthenticationRequestResponse>(url, req);
  }

  public async RequestChangePhoneNumber(req: RequestOtpInputModel): Promise<APIResponseModel<void>> {
    const url = `${this.serviceUrl}/user/change-phone-otp`;
    return await this.post<RequestOtpInputModel, void>(url, req);
  }

  public async VerifyAndChangePhoneNumber(req: VerifyOtpInputModel): Promise<APIResponseModel<string>> {
    const url = `${this.serviceUrl}/otp/verify`;
    try {
      const resp = await this.post<VerifyOtpInputModel, string>(url, req);
      return resp
    } catch (error) {
      const errData: APIResponseModel<string> = {
        success: true,
        message: 'Invalid OTP',
        data: '',
        errors: []
      }
      return errData
    }
  }
}

export function useIdentityAPIClient() {
  const [client, setClient] = useState<BrowserIdentityClient | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setClient(new BrowserIdentityClient());
    }
  }, []);

  return client;
}
